/* eslint-disable no-use-before-define */
/* eslint-disable no-param-reassign */
/* eslint-disable func-names */

(function ($) {
  $(document).ready(() => {
    const containerTemplate = `<div id="oc-modal-container" role="dialog" tabindex="-1" aria-modal="true" style="opacity: 0; display: none;">
    <div id="oc-modal-start" class="sr-only"></div>
      <button id="oc-modal-close" aria-label="close"></button>
      <div id="oc-modal-container-inner"></div>
      <div id="oc-modal-end" class="sr-only"></div>
    </div>`;
    $('#oc-container').prepend(
      `<div id="oc-modal-alert" class="sr-only" role="alert"></div>`
    );
    $('#oc-container').append(containerTemplate);
  });

  const globalSettings = {
    closeFocus: null,
  };

  $.fn.modal = function (selector, options = {}) {
    const $trigger = this;
    const settings = {
      className: 'modal',
      closeOnEsc: true,
      label: 'Modal',
      showAlert: 'Modal opened',
      closeAlert: 'Modal Closed',
      startText: 'Beginning of modal content',
      endText: 'End of modal content',
      closeText: 'Close',
      animationDuration: 500,
      noMobile: false,
      beforeOpenCb: () => false,
      openCb: () => false,
      beforeCloseCb: () => false,
      closeCB: () => false,
      ...options,
    };

    const $alert = $('#oc-modal-alert');
    const $container = $('#oc-modal-container');
    const $inner = $('#oc-modal-container-inner');
    const $start = $('#oc-modal-start');
    const $end = $('#oc-modal-end');
    const $close = $('#oc-modal-close');

    const closeModal = (evt) => {
      settings.beforeCloseCb(evt);
      $container.css({ opacity: 0 });
      $alert.text(settings.closeAlert);

      setTimeout(() => {
        $container.removeClass('open');
        $container.hide();
        $inner.empty();
        $container.removeClass(settings.className);
      }, settings.animationDuration);

      $('html, body').removeClass('scroll-lock');
      $(globalSettings.closeFocus).focus();
      settings.closeCB(evt);
    };

    const closeModalOnEsc = (evt) => {
      if (evt.keyCode === 27) {
        closeModal(evt);
      }
    };

    const openModal = (evt) => {
      if (settings.noMobile && $(window).width() < 768) {
        return false;
      }
      globalSettings.closeFocus = $(evt.currentTarget);
      settings.beforeOpenCb(evt);
      evt.preventDefault();

      const $content = $(selector).children().clone();
      $start.text(settings.startText);
      $end.text(settings.endText);
      $close.html(settings.closeText);
      $inner.append($content);
      $container.addClass('open').addClass(settings.className);
      $container
        .css({ 'transitioni-duration': settings.animationDuration })
        .attr('aira-label', settings.label)
        .show()
        .css({ opacity: 1 })
        .focus();
      $('html, body').addClass('scroll-lock');
      $alert.text(settings.showAlert);
      settings.openCb(evt);
      return true;
    };

    $trigger.on('click', openModal);
    $('#oc-modal-close').on('click', closeModal);
    $(document).on('keydown', closeModalOnEsc);

    return this;
  };
})(jQuery);
